// PersonalCareServicesSection.js
import React from "react";
import { Phone, Check } from "lucide-react";

const PersonalCareServicesSection = () => {
  const services = [
    { left: "Meal preparation", right: "Mobility assistance" },
    {
      left: "Showering and bathing assistance",
      right: "Help with transfers or going up and down the stairs",
    },
    { left: "Incontinence support", right: "Positioning and proper movements" },
    { left: "Meal time assistance", right: "And more!" },
  ];

  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-gray-50">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 text-center leading-tight">
          Personal Care Services Tailored To Your Needs
        </h2>

        <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-8 text-center">
          <p>
            One of the hardest parts about getting older or becoming disabled is
            taking care of yourself. This can become nearly impossible for some
            people. Things like taking a shower or even preparing your meals can
            be stressful and difficult tasks. Allawah Lodge knows your daily
            struggle, and this is why we are offering you the respectful and
            responsive care services you need.
          </p>

          <p className="font-normal">
            Here are a few of the many services included in our personal care:
          </p>
        </div>

        {/* Services Grid */}
        <div className="space-y-4 mb-8">
          {services.map((service, index) => (
            <div key={index} className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="flex items-start gap-3">
                <Check size={20} className="text-gray-700 flex-shrink-0 mt-1" />
                <span className="text-gray-700 font-light">{service.left}</span>
              </div>
              <div className="flex items-start gap-3">
                <Check size={20} className="text-gray-700 flex-shrink-0 mt-1" />
                <span className="text-gray-700 font-light">
                  {service.right}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mb-6">
          <p className="text-gray-700 font-light leading-relaxed">
            We are utterly committed to providing the support you need to live
            life the way you want. If you want to experience our care today,
            please give us a call. We are here to ensure you receive the care
            you deserve.
          </p>
        </div>

        <div className="text-center">
          <a
            href="tel:+61269272706"
            className="inline-flex items-center gap-2 bg-[#E85D2C] hover:bg-[#d54d1f] text-white font-medium px-6 py-3 rounded-full transition-colors"
          >
            <Phone size={20} />
            CALL: (02) 6927 2706
          </a>
        </div>
      </div>
    </section>
  );
};

export default PersonalCareServicesSection;
